import React from 'react'
import PropTypes from 'prop-types'
import { browserHistory } from 'react-router'
import FlatButton from 'material-ui/FlatButton'
import { orange500 } from 'material-ui/styles/colors'
import IconMood from 'material-ui/svg-icons/social/mood'
import Page from '../common/page/Page'
import './Success.less'

export default function Success({ params }) {
	return (
		<Page className="vote success" title="Vote Cast!">
			<p className="thanks">Thank you for voting!</p>
			<p className="thanks">
				<IconMood style={{ color: orange500, width: '60px', height: '60px' }} />
			</p>
			<div className="actions">
				<FlatButton
					label="See results"
					onClick={() => browserHistory.replace(`/${params.pollId}/results`)}
					primary
				/>
			</div>
			<div className="actions">
				<FlatButton
					label="Create your own poll"
					onClick={() => browserHistory.replace('/create')}
				/>
			</div>
		</Page>
	)
}

Success.propTypes = {
	params: PropTypes.shape({
		pollId: PropTypes.string.isRequired,
	}).isRequired,
}



// WEBPACK FOOTER //
// ./src/components/vote/Success.jsx